import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import HttpClient from '../../../api/api';
import {PIdNameModel} from '../types';
import {getSessionCache, setSessionCache} from '../../../utils/session-cache';


const initialState: PIdNameModel[] = []
const PROJECTS_CACHE_KEY = 'cache:projects:filter:list';
const PROJECTS_CACHE_TTL_MS = 1000 * 60 * 15;

export const getProjects = createAsyncThunk(
    'projects/all',
    async () => {
        const cached = getSessionCache<PIdNameModel[]>(PROJECTS_CACHE_KEY);
        if (cached && cached.length > 0) {
            return cached;
        }

        const response = await HttpClient.projectApi.getAllProjects<PIdNameModel[]>();
        setSessionCache(PROJECTS_CACHE_KEY, response.data, PROJECTS_CACHE_TTL_MS);
        return response.data
    }
)

export  const filterProjects = createAsyncThunk(
    'projects/filter',
    async (filter: string) => {
        const response = await HttpClient.projectApi.filterProjects<PIdNameModel[]>(filter);
        return response.data;
    }
)

const typeSplice = createSlice({
    name: 'Eprojects',
    initialState,
    reducers: {
        clear: (state) => {
            return initialState
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getProjects.fulfilled, (state, action) => {
            return [...action.payload];
        })
    }
})

export const { clear } = typeSplice.actions

export default typeSplice.reducer;
